export default {
  TEXT: 'sms',
  PHONE_CALL: 'call',
  EMAIL: 'email',
};
